
import { useState } from 'react';
import { EmailConfig } from '../types/masterLicenseSettings';

export const useEmailConfigManagement = () => {
  const [isSavingEmailConfig, setIsSavingEmailConfig] = useState(false);
  const [isTestingEmailConnection, setIsTestingEmailConnection] = useState(false);

  const handleEmailConfigAdd = async (config: EmailConfig): Promise<boolean> => {
    if (isSavingEmailConfig) return false;
    setIsSavingEmailConfig(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 800));
      return true;
    } catch (error) {
      console.error('Error adding email configuration:', error);
      return false;
    } finally {
      setIsSavingEmailConfig(false);
    }
  };

  const handleEmailConfigUpdate = async (id: string, updates: Partial<EmailConfig>): Promise<boolean> => {
    if (isSavingEmailConfig) return false;
    setIsSavingEmailConfig(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 800));
      return true;
    } catch (error) {
      console.error('Error updating email configuration:', error);
      return false;
    } finally {
      setIsSavingEmailConfig(false);
    }
  };

  const handleEmailConfigDelete = async (id: string): Promise<boolean> => {
    if (isSavingEmailConfig) return false;
    setIsSavingEmailConfig(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 800));
      return true;
    } catch (error) {
      console.error('Error deleting email configuration:', error);
      return false;
    } finally {
      setIsSavingEmailConfig(false);
    }
  };

  const handleTestEmailConnection = async (config: EmailConfig): Promise<boolean> => {
    if (isTestingEmailConnection) return false;
    setIsTestingEmailConnection(true);
    
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      return Math.random() > 0.3;
    } catch (error) {
      console.error('Error testing email connection:', error);
      return false;
    } finally {
      setIsTestingEmailConnection(false);
    }
  };

  return {
    isSavingEmailConfig,
    isTestingEmailConnection,
    handleEmailConfigAdd,
    handleEmailConfigUpdate,
    handleEmailConfigDelete,
    handleTestEmailConnection,
  };
};
